import { DomainEntityType } from '@models';
import { EntityMetadata } from '@ngrx/data';
import { checklistMetadata } from './checklist.metadata';

export const ngrxDataMetadataMap: Partial<
  Record<DomainEntityType, EntityMetadata<any>>
> = {
  [DomainEntityType.Checklist]: checklistMetadata,
};
